import { css } from "@emotion/react";

export const DefaultLayoutStyle = {
  index: () => css`
    min-width: 1200px;
  `,
  main: css``,
};
